import {
  Toaster,
  ToasterProvider,
} from '@foxtrotplatform/developer-platform-common-ui-component-lib';
import {
  PlatformProvider,
  RequireAuthedUser,
} from '@foxtrotplatform/platform-micro-site-core';
import { Windmill } from '@windmill/react-ui';
import { FunctionComponent } from 'react';
import { createHashRouter, Outlet, RouterProvider } from 'react-router-dom';

import { Header } from './common/components/Header';
import { DeveloperAppConfig } from './common/config/developerAppConfig';
import { OrganizationProvider } from './common/providers/OrganizationProvider';
import { TeamProvider } from './common/providers/TeamProvider';
import { LeftNavigation } from './components';
import './index.scss';
import { routes } from './routes';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const windmillTheme = require('@foxtrotplatform/developer-platform-common-ui-component-lib/public/windmillTheme');

const Root: FunctionComponent = () => (
  <OrganizationProvider>
    <TeamProvider>
      <div className="min-h-screen min-w-screen flex-col flex flex-1">
        <Header />
        <div className="flex flex-col md:flex-row min-h-full min-w-full flex-1">
          <RequireAuthedUser>
            <LeftNavigation />
          </RequireAuthedUser>
          <div className="w-full">
            <ToasterProvider>
              <Toaster />
              <Outlet />
            </ToasterProvider>
          </div>
        </div>
      </div>
    </TeamProvider>
  </OrganizationProvider>
);

const router = createHashRouter([
  { path: '/', element: <Root />, children: routes },
]);

interface AppProps {
  config: DeveloperAppConfig;
}

export const App: FunctionComponent<AppProps> = ({ config }) => (
  <Windmill theme={windmillTheme}>
    <PlatformProvider configuration={config}>
      <RouterProvider router={router} />
    </PlatformProvider>
  </Windmill>
);
